import { render } from "./CustomerSiteItemView.vue?vue&type=template&id=f9ddedba"
import script from "./CustomerSiteItemView.vue?vue&type=script&lang=js"
export * from "./CustomerSiteItemView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__